import { useAppSelector } from 'hooks/reduxHooks'

export default function useTargetedBanner() {
  const targetedBannerCampaigns = useAppSelector(state => state.content.targetedBannerCampaigns)

  return targetedBannerCampaigns
}
